import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-45725afb"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "tags-page"
};
var _hoisted_2 = {
  class: "tags-container"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "tag-info"
};
var _hoisted_6 = {
  class: "tag-title"
};
var _hoisted_7 = {
  class: "tag-desc"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "video-icon"
  }, "▶ 播放视频", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsTags, function (tag) {
    return _openBlock(), _createElementBlock("div", {
      class: "tag-card",
      key: tag.id,
      onClick: function onClick($event) {
        return _ctx.$router.push({
          name: 'VideoPlayer',
          params: {
            id: tag.id
          }
        });
      }
    }, [_createElementVNode("img", {
      src: tag.cover,
      alt: "标签封面",
      class: "tag-cover"
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("h3", _hoisted_6, _toDisplayString(tag.title), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(tag.desc), 1), _hoisted_8])], 8, _hoisted_3);
  }), 128))])]);
}